<div class="aeg-admin-invoices-tab">
    <div class="aeg-u-bg-alt aeg-u-box-padding">
        <div class="aeg-u-bg-white aeg-u-box-padding">
            <aeg-search-invoice @search="onSearch" :default-query="defaultSearchQuery" :enable-document-type-filter="true" :enable-service-filter="true" />
        </div>
    </div>

    <aeg-admin-invoices :is-loading="isLoading" :hide-header-pagination="false" :invoices="invoices" @change-page="goToPage" />
</div>


